module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "jumbotron jumbotron-fluid"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('img', {
    staticClass: "img-fluid center-block",
    attrs: {
      "src": require("../assets/deer_logo_svg.svg"),
      "width": "230px",
      "height": "230px"
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "display-4 text-center"
  }, [_vm._v("Predictive Deer Tracker")]), _vm._v(" "), _c('p', {
    staticClass: "lead text-center"
  }, [_c('strong', [_vm._v("\n      Get started by "), _c('a', {
    attrs: {
      "href": '/tracking'
    }
  }, [_vm._v("uploading your images")]), _vm._v(".\n    ")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-33658cc4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home.vue
// module id = 372
// module chunks = 2